export function jobRequestUrl(target, jobId) {
  const path = target.owner_kind === 'org'
    ? `/app/companies/${target.owner_id}/request-job`
    : `/app/contractors/${target.user_uuid}/book`;
  return `${path}${jobId ? `?job=${encodeURIComponent(jobId)}` : ''}`;
}
